import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useNotificationHttp } from '@/core/api/notifications'
import { Notification, NotificationPayload } from '@/core/models/notification'

export type NotificationCollection = {
    data: Array<Notification>,
    meta?: MetaPayload,
    links?: any
}

const state: NotificationCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const notificationCollection: Module<NotificationCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: NotificationCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: NotificationPayload) => {
                state.data.push(new Notification(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useNotificationHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: NotificationCollection): NotificationCollection => {
            return state
        }
    }
}